import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllWalletWithdrawalRequest = createAsyncThunk(
  "Wallet/FindAllWithdrawlRequestForAdmin",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/FindAllWithdrawlRequestForAdmin`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Wallet Withdrawal Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWithdrawalRequest = createAsyncThunk(
  "Wallet/UpdateWithdrawlRequestByAdmin",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/UpdateWithdrawlRequestByAdmin`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Wallet Withdrawal Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWalletWithdrawlRequestByID = createAsyncThunk(
  "Wallet/FindByIDWithdrawlRequest",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/FindByIDWithdrawlRequest`,
        { ID: ID }
      );
      return response.data?.Data as any;
      //   return {
      //     id: result.id,
      //     user_guid: result.user_guid,
      //     first_name: result.first_name,
      //     last_name: result.last_name,
      //     mobileno: result.mobileno,
      //     alternate_mobileno: result.alternate_mobileno,
      //     emailid: result.emailid,
      //     alternate_emailid: result.alternate_emailid,
      //     password: result.password,
      //     isactive: result.isactive === true ? 1 : 2,
      //     usertypeid: result.usertypeid,
      //     ...result?.UserRightsAssign?.reduce(
      //       (
      //         acc: any,
      //         { menu_id, rights_id }: { menu_id: any; rights_id: any }
      //       ) => {
      //         if (!rights_id) {
      //           acc[menu_id] = true;
      //         } else {
      //           acc[`${menu_id}Rights`] = rights_id.split(",").map(Number);
      //           acc[menu_id] = true;
      //         }
      //         return acc;
      //       },
      //       {}
      //     ),
      //   } as IUserDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching withdrawal request details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
